import apiClient from './apiService';

/**
 * User service exposing user related backend data retrieval helpers.
 */
export const userService = {
    /**
     * Fetches the list of users eligible for invoice assignment.
     * @returns Axios promise with user list.
     */
    getUsers() {
        return apiClient.get('/user');
    },
};